// FieldDate Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../common/icon_button/icon_button.jsx'
import DateRangePicker from '../../common/daterange_picker/daterange_picker.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class FieldDate extends Component {
  constructor (props) {
    super(props)

    this._references = {
      calendar: React.createRef()
    }
  }

  static get propTypes () {
    return {
      value: PropTypes.string,
      createdOn: PropTypes.string,
      startDate: PropTypes.object,
      endDate: PropTypes.object,
      isSingleDate: PropTypes.bool,
      subtitle: PropTypes.string,
      displayText: PropTypes.string,
      onChange: PropTypes.func,
      isViewMode: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      value: '',
      createdOn: '',
      startDate: null,
      endDate: null,
      isSingleDate: false,
      subtitle: '',
      displayText: '',
      onChange: null,
      isViewMode: false
    }
  }

  _onShowDatepicker (event) {
    event.preventDefault()

    if (this._references.calendar.current) {
      this._references.calendar.current.show()
    }
  }

  render () {
    const {
      value,
      createdOn,
      onChange,
      startDate,
      endDate,
      isSingleDate,
      subtitle,
      isViewMode,
      ...others
    } = this.props

    let displayText = this.props.displayText || ''
    if (!displayText) {
      displayText = '-'
      if (isSingleDate) {
        displayText = startDate
          ? `${DateUtil.getDisplayPickerDate(new Date(startDate))}`
          : '-'
      } else {
        if (startDate && endDate) {
          displayText = `${DateUtil.getDisplayPickerDate(
            new Date(startDate)
          )} - ${DateUtil.getDisplayPickerDate(new Date(endDate))}`
        } else if (startDate) {
          displayText = `${DateUtil.getDisplayPickerDate(new Date(startDate))}`
        } else if (endDate) {
          displayText = `${DateUtil.getDisplayPickerDate(new Date(endDate))}`
        }
      }
    }

    return (
      <div className='field field-date'>
        {!isViewMode && (
          <div className='pickercont'>
            <IconButton
              size='normal'
              icon='planner'
              type='secondary'
              canHover
              onClick={this._onShowDatepicker.bind(this)}
            />
          </div>
        )}
        <div className={`datecont${isViewMode ? ' viewdate' : ''}`}>
          <span className='date'>{displayText}</span>
          {subtitle && <span className='subtitle'>{subtitle}</span>}
        </div>
        <DateRangePicker
          ref={this._references.calendar}
          placeholder='time.header.calendar'
          name='date'
          isSingleDate={isSingleDate}
          startDate={startDate}
          endDate={endDate}
          onSelect={onChange}
          {...others}
        />
      </div>
    )
  }
}

export default FieldDate
